import Helmet from 'react-helmet';

export interface PageTitleProps {
  title?: string;
  defaultTitle?: string;
  titleTemplate?: string;
}

const PageTitle = ({ title, defaultTitle = 'AvtoApp', titleTemplate = 'AvtoApp - %s' }: PageTitleProps) => {
  return (
    <Helmet defaultTitle={ defaultTitle } titleTemplate={ titleTemplate }>
      <title>{ title }</title>
    </Helmet>
  );
};

/**
 * HOC оборачивает компонент титулом страницы (react-helmet).
 *
 * `class Title extends Component` — наследование от самого функционального
 * компонента (легаси-приём из .jsx-версии, работает только для обычных function
 * declarations — НЕ стрелочных). Потребитель — lib/router/routes.js.
 */
export const withTitle = ({ component: Component, title }: { component: any; title?: string }) => {
  const Base = Component as any;

  return class Title extends Base {
    render() {
      return (
        <>
          <PageTitle title={ title } />
          <Component { ...this.props } />
        </>
      );
    }
  };
};

export default PageTitle;
